import React from 'react';
import { useNavigate } from 'react-router-dom';

import { useTranslation } from '@/config/i18n';
import PATH from '@/routes/path';
import GraduationForm from '@/pages/graduation-management/components/GraduationForm';

const GraduationManagementNewPage: React.FC = () => {
  const [t] = useTranslation('');
  const navigate = useNavigate();

  return (
    <>
      <div className="header-top">
        <h2 className="title flex">
          <span
            className="pi pi-arrow-left text-[20px] text-gray-500 cursor-pointer"
            onClick={() => navigate(PATH.graduation)}
          ></span>
          <span className="ml-3">{t('graduation.add_new')}</span>
        </h2>
      </div>
      <GraduationForm />
    </>
  );
};

export default GraduationManagementNewPage;
